module.exports = __webpack_public_path__ + "img/userbg.e22b8e49.png";